module.exports = __webpack_public_path__ + "static/media/proyects-import.228f06cb.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proyects-import.csv
// module id = ./src/assets/proyects-import.csv
// module chunks = 11